export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5352.12dfc833.jpg";